<template>
  <div>
    <div class="home">
      <div class="content">
        <p>
          KKPoker does not provide service in the following countries and territories:
        </p>
        <ul>
            <li>Afghanistan</li>
            <li>American Samoa</li>
            <li>Australia and its territories</li>
            <li>Azerbaijan</li>
            <li>Belarus</li>
            <li>Belgium</li>
            <li>China</li>
            <li>Cuba</li>
            <li>Denmark</li>
            <li>French Republic and its territories</li>
            <li>Germany</li>
            <li>Greece</li>
            <li>Guam</li>
            <li>Hong Kong</li>
            <li>Iran</li>
            <li>Iraq</li>
            <li>Isle of Man</li>
            <li>Italy</li>
            <li>Kenya</li>
            <li>Libya</li>
            <li>Lithuania</li>
            <li>Macao</li>
            <li>Malta</li>
            <li>Marshall Islands</li>
            <li>Midway Islands</li>
            <li>Mozambique</li>
            <li>Myanmar (Burma)</li>
            <li>Netherlands</li>
            <li>Nigeria</li>
            <li>North Korea</li>
            <li>Northern Marianas Islands</li>
            <li>Ontario Province, Canada</li>
            <li>Pakistan</li>
            <li>Palestinian Territories</li>
            <li>Portugal</li>
            <li>Puerto Rico</li>
            <li>Russia</li>
            <li>Rwanda</li>
            <li>Senegal</li>
            <li>Seychelles</li>
            <li>Singapore</li>
            <li>Spain</li>
            <li>Sudan</li>
            <li>Sweden</li>
            <li>Switzerland</li>
            <li>Syria</li>
            <li>Taiwan</li>
            <li>United Kingdom</li>
            <li>United States of America</li>
            <li>United States Minor Outlying Islands</li>
            <li>United States Virgin Islands</li>
            <li>Vatican City</li>
            <li>Virgin Islands and St.Croix Islands</li>
            <li>Wake Islands</li>
            <li>Yemen</li>
            <li>Zimbabwe</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'countries'
}
</script>

<style lang="scss" scoped>
  .home {
    position: relative;

    background-image: url("/mobile/static/img/country/m_bg.jpg");
    background-repeat: no-repeat;
    // background-size: cover;
    background-position: top center;
    background-size: 100% auto;
    background-color: #050505;

    width: 100%;
    font-size: 24px;
    color: #ccc5c5;
    .content {
      width: 80%;
      margin: 0 auto;
      padding: 320px 0 100px 0;
      p {
        margin-bottom: 20px;
        font-size: 28px;
      }
    }
  }
</style>
